<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ViewDetails from '../ViewDetails/index.vue';
export default {
	components: {
		ViewDetails,
	},
	props: {},
	watch: {},
	data() {
		return {
			//搜索框
			searchlist: getdata().searchlist,
			// 红字发票确认信息 表格
			tableData: [{}, {}, {}, {}, {}],
			tablekey: 0,
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('ConfirmationInformationProcessingheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('ConfirmationInformationProcessingoutlist')) || [],
			overlength:0,
			//查看详情
			HuanqViewDetails: false,
		};
	},
	mounted() {},
	created() {},
	methods: {
		//查看详情回调
		closediagViewDetails(e) {
			this.HuanqViewDetails = false;
		},
		geOoverLength(e) {
			this.overlength = e;
		},
		//返回
		switchInterfaceHuid() {
			this.$emit('switchInterfaceHuid', 0);
		},
		// 表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		// 存缓存示例
		confirmfilter(e) {
			localStorage.setItem('ConfirmationInformationProcessingoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('ConfirmationInformationProcessingheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		// 表格字段排序
		sortchange(e) {
			console.log(e);
		},
		// 显示条数
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		// 显示页码
		currentChange(e) {
			this.pagination.pageNum = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
